import { SimpleShowLayout, Show, TextField, Labeled } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";

const ShowExams = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за изпит"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Описание">
              <TextField source="description" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowExams;
